import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";

import { trackPopupViewEvent } from "../../tracking/googleAnalytics";
import { getInsuranceContent } from "../../utils/helpers/insurance";
import { useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";
import icons from "../../utils/svgProvider";

export const InsuranceContent = () => {
	const [showMore, toggleShowMore] = useState(false);
	const [hightlightHeight, setHightlightHeight] = useState(0);

	const groupId = useSelector(
		(state) => state.popup.products.mainProduct.groupId,
	);

	const contentRef = useRef(null);

	const content = getInsuranceContent({ groupId, isFlexInsurance: false });

	const trackModalLinkClick = () => {
		trackPopupViewEvent({
			category: "Information",
			name: "Standard insurance modal link click",
		});
	};

	useEffect(() => {
		if (contentRef?.current) {
			const listItems = contentRef?.current.querySelectorAll("ul > li");

			setHightlightHeight(
				[
					listItems[0]?.getBoundingClientRect().height,
					listItems[1]?.getBoundingClientRect().height,
					listItems[2]?.getBoundingClientRect().height,
				].reduce((accumulator, currentValue) => {
					return accumulator + currentValue;
				}, 0) + 4,
			);
		}

		const link = contentRef?.current?.querySelector("a");
		link?.addEventListener("click", () => trackModalLinkClick());

		return () =>
			link?.removeEventListener("click", () => trackModalLinkClick());
	}, []);

	return (
		<div className="addtocartpopupModal--wrapper">
			<div className="addtocartpopupModal--content addtocartpopupModal--content__default">
				<div
					ref={contentRef}
					className="addtocartpopupModal--row"
					style={{
						maxHeight: showMore ? "100%" : `${hightlightHeight}px`,
						overflow: "hidden",
					}}
					dangerouslySetInnerHTML={{
						__html: content.modal,
					}}
				/>
				<a
					href="#"
					className="read-more-link"
					onClick={(e) => {
						e.preventDefault();
						toggleShowMore(!showMore);
					}}
				>
					{showMore
						? strings["addtocartpopup.insurance.readless"]
						: strings["addtocartpopup.insurance.readmore"]}{" "}
					<span
						className={classNames({
							"read-more-link-icon": true,
							"is-open": showMore,
						})}
					>
						{icons.chevron}
					</span>
				</a>
			</div>
		</div>
	);
};
